export default __webpack_public_path__ + "static/15-7e97d88b29725d3a25bd804516be5e9f.png";